/* @flow */

import { combineReducers } from 'redux';

import appTopicsReducer from './appTopicsReducer';
import * as interestNamespaces from 'src/shared/app/interest/action/interestActionNamespaces';
import * as userNamespaces from 'src/shared/domain/user/action/userActionNamespaces';

import interestReducer from 'src/shared/app/interest/reducer/interestReducer';
import accountReducer from 'src/shared/app/account/base/reducer/accountReducer';
import profileReducer from 'src/shared/app/account/profile/reducer/profileReducer';
import publicProfileReducer from 'src/shared/app/account/profile/reducer/publicProfileReducer';
import * as publicProfileNamespaces from 'src/shared/domain/topic/action/topicActionNamespaces';
import appAuthenticationBaseReducer from 'src/shared/app/authentication/reducer/base/appAuthenticationBaseReducer';
import appAuthenticationSupportReducer from 'src/shared/app/authentication/reducer/support/appAuthenticationSupportReducer';
import appDeviceReducer from 'src/shared/app/base/reducer/appDeviceReducer';
import appEnvReducer from 'src/shared/app/base/reducer/appEnvReducer';
import appEventReducer from 'src/shared/app/base/reducer/appEventReducer';
import conversationReducer from 'src/shared/app/conversation/reducer/conversationReducer';
import faqReducer from 'src/shared/app/faq/reducer/faqReducers';
import appMembershipReducer from 'src/shared/app/base/reducer/appMembershipReducer';
import appUserReducer from 'src/shared/app/base/reducer/appUserReducer';
import appUsersReducer from 'src/shared/app/user/reducer/appUsersReducer';
import userReducer from 'src/shared/app/user/reducer/userReducer';
import appBraindatesReducer from 'src/shared/app/braindate/reducer/appBraindateReducer';
import quickActionReducer from 'src/shared/app/braindate/reducer/quickActionReducer';
import integrationReducer from 'src/shared/app/integration/reducer/integrationReducer';
import inspirationReducer from 'src/shared/app/inspiration/reducer/inspirationReducer';
import marketReducer from 'src/shared/app/market/reducer/marketReducer';
import appLocaleReducer from 'src/shared/app/locale/reducer/appLocaleReducer';
import perfReducer from 'src/shared/app/perf/reducer/perfReducer';
import appSignupReducer from 'src/shared/app/signup/reducer/appSignupReducer';
import appNewTopicReducer from 'src/shared/app/topic/new/reducer/newTopicReducer';
import * as newTopicKeywordNamespaces from 'src/shared/app/topic/new/action/appNewTopicActionNamespaces';
import newTopicKeywordReducer from 'src/shared/app/topic/new/reducer/newTopicKeywordReducer';
import eventTimeSlotsSuggestionsReducer from 'src/shared/app/event/reducer/eventTimeSlotsSuggestionsReducer';
import appPluginsReducer from 'src/shared/app/base/reducer/appPluginsReducer';
import appLocationReducer from 'src/shared/domain/location/reducer/appLocationsReducer';
import { createFilteredReducer } from 'src/shared/core/util/reducerUtils';
import appPermissionReducer from 'src/shared/app/permission/reducer/appPermissionReducer';
import appNotificationsReducer from 'src/shared/app/notification/reducer/appNotificationsReducer';
import appLanguagesSlice from 'src/shared/domain/user/slice/appLanguagesSlice';
import expressionOfGratitudeSlice from '../../expression-of-gratitude/reducer/expressionOfGratitudeSlice';

// $FlowIssue
const appReducer = combineReducers({
  account: accountReducer,
  authentication: appAuthenticationBaseReducer,
  braindates: appBraindatesReducer,
  conversation: conversationReducer,
  device: appDeviceReducer,
  env: appEnvReducer,
  event: appEventReducer,
  eventTimeSlotsSuggestions: eventTimeSlotsSuggestionsReducer,
  faq: faqReducer,
  profile: profileReducer,
  publicProfile: createFilteredReducer(
    publicProfileReducer,
    (action) =>
      action.namespace === publicProfileNamespaces.USER_RELATED_TOPICS,
  ),
  inspiration: inspirationReducer,
  integration: integrationReducer,
  interest: createFilteredReducer(
    interestReducer,
    (action) => action.namespace === interestNamespaces.INTEREST_KEYWORDS,
  ),
  interestAutocomplete: createFilteredReducer(
    interestReducer,
    (action) => action.namespace === interestNamespaces.INTEREST_AUTOCOMPLETE,
  ),
  language: appLocaleReducer,
  languages: appLanguagesSlice,
  location: appLocationReducer,
  market: marketReducer,
  membership: appMembershipReducer,
  notifications: appNotificationsReducer,
  newTopic: appNewTopicReducer,
  newTopicKeyword: createFilteredReducer(
    newTopicKeywordReducer,
    (action) =>
      action.namespace === newTopicKeywordNamespaces.NEW_TOPIC_KEYWORDS,
  ),
  newTopicRecommendedKeyword: createFilteredReducer(
    newTopicKeywordReducer,
    (action) =>
      action.namespace ===
      newTopicKeywordNamespaces.NEW_TOPIC_RECOMMENDED_KEYWORDS,
  ),
  perf: perfReducer,
  quickAction: quickActionReducer,
  topics: appTopicsReducer,
  user: appUserReducer,
  users: appUsersReducer,
  expressionOfGratitude: expressionOfGratitudeSlice,
  userAutocomplete: createFilteredReducer(
    userReducer,
    (action) => action.namespace === userNamespaces.USER_AUTOCOMPLETE,
  ),
  signup: appSignupReducer,
  support: appAuthenticationSupportReducer,
  plugins: appPluginsReducer,
  permission: appPermissionReducer,
});

export default appReducer;
